// Generic registry mapping a backend error `code` (string) to a handler
// that runs when the global axios response interceptor catches an error
// carrying that code. Features own their own handlers — register from
// inside the feature module so the interceptor stays feature-agnostic.
//
// Handler signature: (error, store) => void
// - error: the axios error object (with error.response.data, etc.)
// - store: the Redux store (dispatch is the typical use)

const handlers = {};

export const registerErrorCodeHandler = (code, fn) => {
  handlers[code] = fn;
};

export const getErrorCodeHandler = code => handlers[code];

// Only exposed for tests — reset between cases.
export const _clearErrorCodeHandlers = () => {
  Object.keys(handlers).forEach(k => delete handlers[k]);
};
